module.exports = __webpack_public_path__ + "static/img/nest-cooling.921337c.png";